const householdStore = {
    'thomas family': {
        householdId: 'thomas-family',
        householdName: 'Thomas Family',
        lookupCode: 'thomas-family',
        canEdit: true,
        lastUpdated: null,
        members: [
            {
                id: 'mary-thomas',
                name: 'Mary Thomas',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
            {
                id: 'john-thomas',
                name: 'John Thomas',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
        ],
    },
    'rivera household': {
        householdId: 'rivera-household',
        householdName: 'Rivera Household',
        lookupCode: 'rivera-household',
        canEdit: true,
        lastUpdated: '2026-02-21T00:00:00Z',
        members: [
            {
                id: 'sofia-rivera',
                name: 'Sofia Rivera',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: true,
                plusOneGuestId: 'guest-elena-park',
                bringingPlusOne: true,
                attendance: {
                    hike: 'yes',
                    ceremony: 'yes',
                    reception: 'yes',
                    brunch: 'no',
                },
                entree: 'fish',
                allergies: 'Shellfish allergy',
                notes: 'Prefers an aisle seat.',
            },
            {
                id: 'guest-elena-park',
                name: 'Elena Park',
                isPlusOneGuest: true,
                primaryGuestId: 'sofia-rivera',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {
                    hike: 'no',
                    ceremony: 'yes',
                    reception: 'yes',
                    brunch: 'yes',
                },
                entree: 'veggie',
                allergies: 'Nut allergy',
                notes: '',
            },
            {
                id: 'daniel-rivera',
                name: 'Daniel Rivera',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {
                    ceremony: 'yes',
                    reception: 'yes',
                    brunch: 'yes',
                },
                entree: 'beef',
                allergies: '',
                notes: '',
            },
        ],
    },
    'curtis promislow household': {
        householdId: 'curtis-promislow-household',
        householdName: 'Curtis Promislow Household',
        lookupCode: 'curtis-promislow-household',
        canEdit: true,
        lastUpdated: '2026-03-02T00:00:00Z',
        members: [
            {
                id: 'curtis-promislow',
                name: 'Curtis Promislow',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: true,
                plusOneGuestId: 'guest-mackenzie-smith',
                bringingPlusOne: true,
                attendance: {
                    hike: 'yes',
                    ceremony: 'yes',
                    reception: 'yes',
                    brunch: '',
                },
                entree: 'beef',
                allergies: '',
                notes: '',
            },
            {
                id: 'guest-mackenzie-smith',
                name: 'MacKenzie Smith',
                isPlusOneGuest: true,
                primaryGuestId: 'curtis-promislow',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {
                    hike: '',
                    ceremony: 'yes',
                    reception: 'yes',
                    brunch: 'no',
                },
                entree: 'fish',
                allergies: 'Dairy-free',
                notes: '',
            },
        ],
    },
    'thomas jeffries': {
        householdId: 'thomas-jeffries',
        householdName: 'Thomas Jeffries and Alysia Promislow',
        lookupCode: 'thomas-jeffries',
        canEdit: true,
        lastUpdated: null,
        members: [
            {
                id: 'thomas-jeffries',
                name: 'Thomas Jeffries',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
            {
                id: 'alysia-promislow',
                name: 'Alysia Promislow',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
        ],
    },
    'will jeffries': {
        householdId: 'will-jeffries',
        householdName: 'Will and Jean Jeffries',
        lookupCode: 'will-jeffries',
        canEdit: true,
        lastUpdated: null,
        members: [
            {
                id: 'will-jeffries',
                name: 'Will Jeffries',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
            {
                id: 'jean-jeffries',
                name: 'Jean Jeffries',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: false,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
        ],
    },
    'nat jeffries': {
        householdId: 'nat-jeffries',
        householdName: 'Nat Jeffries',
        lookupCode: 'nat-jeffries',
        canEdit: true,
        lastUpdated: null,
        members: [
            {
                id: 'nat-jeffries',
                name: 'Nat Jeffries',
                invitedEvents: ['hike', 'ceremony', 'reception', 'brunch'],
                plusOneAllowed: true,
                bringingPlusOne: false,
                attendance: {},
                entree: '',
                allergies: '',
                notes: '',
            },
        ],
    },
};

const ENV_API_BASE_URL = (process.env.REACT_APP_RSVP_API_BASE_URL || '').replace(/\/$/, '');
const RSVP_API_SECRET = 'alysia-thomas-rsvp-test-secret-2026-03-30';
const CONFIG_URL = `${process.env.PUBLIC_URL || ''}/config.json`;

let configPromise;

const loadRuntimeConfig = async () => {
    if (!configPromise) {
        configPromise = fetch(CONFIG_URL, { cache: 'no-store' })
            .then((response) => {
                if (!response.ok) {
                    return {};
                }
                return response.json();
            })
            .catch(() => ({}));
    }

    return configPromise;
};

const getApiBaseUrl = async () => {
    const config = await loadRuntimeConfig();
    const configuredApiBaseUrl = (config.rsvpApiBaseUrl || ENV_API_BASE_URL).trim();

    if (configuredApiBaseUrl === 'same-origin') {
        return window.location.origin;
    }

    return configuredApiBaseUrl.replace(/\/$/, '');
};

const delay = (ms) => new Promise((resolve) => {
    window.setTimeout(resolve, ms);
});

const clone = (value) => JSON.parse(JSON.stringify(value));

const normalizeLookupValue = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ');

const slugify = (value) => normalizeLookupValue(value)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const RSVP_CUTOFF_LABEL = 'July 26th, 2026';

export const RSVP_EVENTS = [
    { id: 'hike', label: 'Friday morning hike', description: 'A relaxed ~3 mile hike with scenic views.' },
    { id: 'ceremony', label: 'Saturday wedding ceremony', description: 'Our afternoon ceremony at the Meeting House.' },
    { id: 'reception', label: 'Saturday dinner and reception', description: 'Plated dinner at the Old Inn on the Green, followed by music and dancing.' },
    { id: 'brunch', label: 'Sunday farewell brunch', description: 'A casual send-off before everyone heads home.' },
];

const requestJson = async (path, options = {}) => {
    const apiBaseUrl = await getApiBaseUrl();
    const response = await fetch(`${apiBaseUrl}${path}`, {
        headers: {
            'Content-Type': 'application/json',
            'x-rsvp-secret': RSVP_API_SECRET,
            ...(options.headers || {}),
        },
        ...options,
    });

    const text = await response.text();
    const body = text ? JSON.parse(text) : null;

    if (!response.ok) {
        const error = new Error(body?.message || 'Request failed.');
        error.status = response.status;
        error.body = body;
        throw error;
    }

    return body;
};

const lookupMockHousehold = async (query) => {
    await delay(500);
    const key = normalizeLookupValue(query);
    const household = Object.values(householdStore).find((entry) => (
        entry.lookupCode === key
        || entry.householdId === key
        || entry.members.some((member) => normalizeLookupValue(member.name) === key)
    ));

    if (!household) {
        return null;
    }

    return clone(household);
};

const buildMockPlusOneGuest = (household, primaryMember, plusOnePayload) => {
    const baseId = `guest-${slugify(plusOnePayload.name)}`;
    const existingIds = new Set(household.members.map((member) => member.id));
    let guestId = baseId;
    let suffix = 2;

    while (existingIds.has(guestId)) {
        guestId = `${baseId}-${suffix}`;
        suffix += 1;
    }

    return {
        id: guestId,
        name: plusOnePayload.name.trim(),
        isPlusOneGuest: true,
        primaryGuestId: primaryMember.id,
        invitedEvents: [...primaryMember.invitedEvents],
        plusOneAllowed: false,
        bringingPlusOne: false,
        attendance: { ...(plusOnePayload.attendance || {}) },
        entree: plusOnePayload.entree || '',
        allergies: plusOnePayload.allergies || '',
        notes: plusOnePayload.notes || '',
    };
};

const saveMockHouseholdRsvp = async (householdId, selectedMemberIds, responses) => {
    await delay(700);

    const household = Object.values(householdStore).find((entry) => entry.householdId === householdId);
    if (!household) {
        throw new Error('Household not found.');
    }

    const selectedIds = new Set(selectedMemberIds);

    Object.entries(responses).forEach(([memberId, update]) => {
        if (!selectedIds.has(memberId)) {
            return;
        }

        const memberIndex = household.members.findIndex((member) => member.id === memberId);
        if (memberIndex === -1) {
            return;
        }

        const nextUpdate = clone(update);
        const plusOnePayload = nextUpdate.plusOneGuest;
        delete nextUpdate.plusOneGuest;

        household.members[memberIndex] = {
            ...household.members[memberIndex],
            ...nextUpdate,
        };

        if (plusOnePayload) {
            const plusOneGuest = buildMockPlusOneGuest(household, household.members[memberIndex], plusOnePayload);
            household.members.push(plusOneGuest);
            household.members[memberIndex].plusOneGuestId = plusOneGuest.id;
        }
    });

    household.lastUpdated = '2026-03-28T00:00:00Z';

    return clone(household);
};

export const lookupHousehold = async (query) => {
    const apiBaseUrl = await getApiBaseUrl();
    if (!apiBaseUrl) {
        return lookupMockHousehold(query);
    }

    const result = await requestJson('/rsvp/lookups', {
        method: 'POST',
        body: JSON.stringify({ query }),
    });
    return result.household;
};

export const saveHouseholdRsvp = async (householdId, selectedMemberIds, responses) => {
    const apiBaseUrl = await getApiBaseUrl();
    if (!apiBaseUrl) {
        return saveMockHouseholdRsvp(householdId, selectedMemberIds, responses);
    }

    const result = await requestJson(`/rsvp/households/${householdId}/responses`, {
        method: 'PUT',
        body: JSON.stringify({
            selectedMemberIds,
            responses,
        }),
    });
    return result.household;
};
